class Constants {
  static {
    this.emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  }
  static {
    this.phoneNumberRegex = /^\d+$/;
  }
  static {
    this.GuidEmpty = "00000000-0000-0000-0000-000000000000";
  }
  static {
    this.DecimalMinValue = "-7.922816251426434e+28";
  }
  static {
    this.InputLockTimeSpan = 500;
  }
  static {
    this.MinDate = "0001-01-01T00:00:00";
  }
  static {
    this.MinTime = "00:00:00";
  }
  static {
    this.MinDecimal = "-79228162514264337593543950335";
  }
  static StringFormat(msg, ...args) {
    for (let _i = 0; _i < args.length; _i++) {
      msg = msg.replace(`{${_i}}`, args[_i]);
    }
    return msg;
  }
  static {
    this.isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  static IsNotEmpty(value) {
    if (value != "" && !Constants.containsOnlySpaces(value) && value != Constants.GuidEmpty && value != undefined && value != null) {
      return true;
    } else {
      return false;
    }
  }
  static IsEmpty(value) {
    if (value == "" || Constants.containsOnlySpaces(value) || value == undefined || value == null || value == Constants.GuidEmpty) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * Checks if a string is a valid GUID.
   * @param guid - The string to be checked.
   * @returns True if the string is a valid GUID, false otherwise.
   */
  static isGuid(guid) {
    const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
    let isGuid = false;
    if (guid) {
      isGuid = regexExp.test(guid);
    }
    return isGuid;
  }
  // check whether string only contains blank space
  static containsOnlySpaces(str) {
    return /^\s*$/.test(str);
  }
  static FilterByID(array, id) {
    try {
      const list = array.filter(x => x.ID == id);
      if (list.length > 0) {
        return list[0];
      }
    } catch (ex) {}
    return null;
  }
  static {
    this.Months = [{
      ID: 1,
      Label: "January"
    }, {
      ID: 2,
      Label: "February"
    }, {
      ID: 3,
      Label: "March"
    }, {
      ID: 4,
      Label: "April"
    }, {
      ID: 5,
      Label: "May"
    }, {
      ID: 6,
      Label: "June"
    }, {
      ID: 7,
      Label: "July"
    }, {
      ID: 8,
      Label: "August"
    }, {
      ID: 9,
      Label: "September"
    }, {
      ID: 10,
      Label: "October"
    }, {
      ID: 11,
      Label: "November"
    }, {
      ID: 12,
      Label: "December"
    }];
  }
  static GenerateYears(currYear, length, IsPrevious) {
    let multiplier = -1;
    if (length == undefined || length == null) length = 11;
    if (IsPrevious == undefined || IsPrevious == null || !IsPrevious) multiplier = 1;
    const years = [];
    for (let i = 0; i < length; i++) {
      years.push(currYear + i * multiplier);
    }
    return years;
  }
  /**
   * Refactor function
   * @param date
   */
  static DateOnly(date) {
    if (date) {
      return new Date(new Date(date).toDateString());
    } else {
      return new Date(new Date().toDateString());
    }
  }
  /**
   * javascript difference between two dates in days
   * @param startDate
   * @param endDate
   * @returns
   */
  static differentInDays(startDate, endDate) {
    // To calculate the time difference of two dates
    let Difference_In_Time = endDate.getTime() - startDate.getTime();
    // To calculate the no. of days between two dates
    let Difference_In_Days = Math.floor(Difference_In_Time / (1000 * 3600 * 24));
    return Difference_In_Days;
  }
  /**
   *  javascript difference between two dates in minutes
   * @param dt1
   * @param dt2
   * @returns
   */
  static minutesDiff(dt1, dt2) {
    let diffMin = (dt2.getTime() - dt1.getTime()) / 60000;
    return Math.ceil(diffMin);
  }
  /**
   * Calculate the difference between two dates in hours javascript
   * @param dt1
   * @param dt2
   * @returns
   */
  static hoursDiff(dt1, dt2) {
    // calculate the time difference of two dates JavaScript
    let diffTime = dt2.getTime() - dt1.getTime();
    // calculate the number of days between hours dates javascript
    let hoursDiff = diffTime / (1000 * 3600);
    return parseFloat(hoursDiff.toFixed(1));
  }
  /**
   * Create Unique Identifier in the Client Side equivalent to C# NewGuid()
   * @returns
   */
  static Guid_NewGuid() {
    let dt = new Date().getTime();
    let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
    return uuid;
  }
  static parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(atob(base64).split("").map(function (c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    return JSON.parse(jsonPayload);
  }
  static numberOnly(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  /**
   * format number to unit
   * @param total
   * @returns
   */
  static formatNumber(total) {
    let value = '';
    let unit = "";
    let absNumber = Math.abs(total);
    if (absNumber > 999 && absNumber < 1000000) {
      unit = "K";
      value = (absNumber / 1000).toFixed(0);
    } else if (absNumber >= 1000000) {
      unit = "M";
      value = (absNumber / 1000000).toFixed(0);
    } else if (absNumber < 999) {
      value = absNumber.toString(); //
    }
    if (total < 0) {
      value = "-" + value;
    }
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + unit;
  }
  static isToDay(date) {
    if (this.IsNotEmpty(date)) {
      date = typeof date == "string" ? new Date(date) : date;
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);
      return now.getTime() == date.getTime();
    }
    return false;
  }
  /**
   * set date time to latest time day
   * @param date
   * @returns
   */
  static setToLatestTime(date) {
    const dateLastTime = new Date(date);
    dateLastTime.setHours(23, 59, 59);
    return dateLastTime;
  }
  /**
   * set date time to first time day
   * @param date
   * @returns
   */
  static setToFirstTime(date) {
    const dateFirstTime = new Date(date);
    dateFirstTime.setHours(0, 0, 0);
    return dateFirstTime;
  }
  static compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  /**
   * generate serial as note with format ['serial'*Quantity]
   * ex: [00AS32*6, 0089A]
   * @param serials
   * @returns
   */
  static generateSerialasNote(serials = []) {
    let serialNote = '';
    if (serials && serials.length > 0) {
      let serialASString = serials.map((serial, i) => {
        return `${i > 0 ? " " : ""}${serial.Number}${serial.Quantity > 1 || serial.Quantity < 0 ? "*" + serial.Quantity : ""}`;
      });
      serialNote = `[${serialASString}]`;
    }
    return serialNote;
  }
  static getDatesInRange(startDate, endDate) {
    const date = new Date(startDate.getTime());
    const dates = [];
    while (date <= endDate) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return dates;
  }
  /**
   * @param date
   * @param daysBefore
   * @returns
   */
  static getDaysBefore(date, daysBefore) {
    return new Date(date.setDate(new Date().getDate() - daysBefore));
  }
  /**
   * get first and last day by month and year
   * @param month
   * @param year
   * @returns
   */
  static getRangeDate(month, year) {
    const date = new Date();
    date.setMonth(month);
    date.setFullYear(year);
    let firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    let lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
    return {
      firstDay: firstDay,
      lastDay: lastDay
    };
  }
  static setDateTime(time, date) {
    let newDate = new Date();
    if (date) {
      newDate = new Date(date);
    }
    let times = time.split(":");
    newDate.setHours(parseInt(times[0]));
    newDate.setMinutes(parseInt(times[1]));
    return newDate;
  }
  static isMaskingField(value = "") {
    const hasQuestionMark = value.includes("?");
    return hasQuestionMark;
  }
  static generateMaskingField(configMaskingField = []) {
    let maskingFields = {};
    configMaskingField.forEach((field, i) => {
      field = field.split(' ')?.join('');
      maskingFields = {
        ...maskingFields,
        [field]: true
      };
    });
    return maskingFields;
  }
  /**
  * Check if JS API function is supported in a current browser
  * @param api ex: structuredClone
  */
  static checkJSApiSupported(api) {
    let isSupported;
    if (api in window) {
      isSupported = true;
    } else {
      isSupported = false;
    }
    return isSupported;
  }
  /**
   * copy of all elements of the original object.
   * Changes made to the original object will not be reflected in the copy
   * @param object
   * @param type
   */
  static cloneObject(object) {
    let newObject;
    if (this.checkJSApiSupported('structuredClone')) {
      newObject = structuredClone(object);
    } else {
      newObject = JSON.parse(JSON.stringify(object));
    }
    return newObject;
  }
  /**
  * format title for from filter to showing in title
  * @param startDate
  * @param endDate
  * @returns
  */
  static formatTitleFromDate(startDate, endDate) {
    let format = null;
    const startDateObj = new Date(startDate);
    const endDateObj = new Date(endDate);
    if (startDateObj.getDate() != endDateObj.getDate()) {
      format = "d";
    }
    // set format only days on same month
    if (startDateObj.getMonth() != endDateObj.getMonth()) {
      format = "d MMM";
    }
    // set full format when different year
    if (startDateObj.getFullYear() != endDateObj.getFullYear()) {
      format = "d MMM yyyy";
    }
    return format;
  }
}
function getImageInfo(src) {
  return new Promise((resolve, reject) => {
    let image = new Image();
    image.src = src;
    image.decode().then(() => {
      resolve({
        img: src,
        height: image.height,
        width: image.width
      });
    }).catch(() => {
      reject(new Error(`Image load error for ${src}`));
    });
  });
}
class LocalDataKey {
  static {
    this.OfflineQueryMode = "OfflineQueryMode";
  }
  static {
    this.POSStorage = "POSStorage";
  }
  static {
    this.Products = "Products";
  }
  static {
    this.Customers = "Customers";
  }
  static {
    this.OutletPrices = "OutletPrices";
  }
  static {
    this.Outlet = "Outlet";
  }
  static {
    this.Parks = "Parks";
  }
  static {
    this.Orders = "Orders";
  }
  static {
    this.FailedOrders = "FailedOrders";
  }
  static {
    this.CompletedOrders = "CompletedOrders";
  }
  static {
    this.NewCustomers = "NewCustomers";
  }
  static {
    this.GetRewardByPromotionID = "/API/POS/GetRewardByPromotionID";
  }
  static {
    this.GetListPromotion = "/API/POS/Promotion";
  }
  static {
    this.GenerateGopayQrCode = "/API/POS/GenerateGoPayQrCode";
  }
  static {
    this.GenerateEmpatKaliQrCode = "/API/POS/GenerateEmpatKaliQrCode";
  }
  static {
    this.VerifyPayment = "/API/PaymentNotification/VerifyPayment";
  }
  static {
    this.PayWithOvo = "/API/POS/PayWithOvo";
  }
  static {
    this.InvoiceA4 = "/API/Print/Invoice";
  }
  static {
    this.UploadCsv = "/API/POS/UploadCsv";
  }
  static {
    this.UploadCsvBuy = "/API/Buy/UploadCsv";
  }
  static {
    this.GenerateCommission = "/API/Transaction/GetCommission";
  }
  static {
    this.InvoiceInfo = "/api/Invoice/InvoiceInfo";
  }
  static {
    this.GenerateLink = "/API/PayNow/GenerateLink";
  }
  //Buy
  static {
    this.LoadFormBuy = "/API/Buy2/Load";
  }
  static {
    this.BuyGetOutletInfo = "/API/Buy2/GetOutletInfo";
  }
  static {
    this.BuyGenerateNumber = "/API/Buy/GenerateNumber";
  }
  static {
    this.BuyGetDataByID = "/API/Buy2/GetDataByID";
  }
  static {
    this.GetQuickKey = "/API/catalog/product/GetQuickKey";
  }
  static {
    this.GetPrintTemplateID = "/API/Buy/GetPrintTemplateID";
  }
  static {
    this.GetVariantStockByID = "/API/catalog/variant/GetInventoryByVariantID";
  }
  static {
    this.GetSupplierInvoice = "/API/Buy/GetSupplierInvoiceRetur";
  }
  static {
    this.GetSupplierDTO = "/API/Contact/GetSupplierDTO";
  }
  //DELIVERY
  static {
    this.LoadFormDelivery = "/API/TransferOrderLoader/LoadForm";
  }
  static {
    this.DeliveryGenerateNumber = "/API/TransferOrder/GenerateNumber";
  }
  static {
    this.UpdateCourierList = "/API/TransferOrder/UpdateCourierList";
  }
  static {
    this.SubmitOutletDelivery = "/API/TransferOrder/SubmitOrder";
  }
  static {
    this.ClearOutlet = "/API/TransferOrder/ClearOutlet";
  }
  static {
    this.PaymentListSorting = "/API/Setup/SortPaymentMethod";
  }
  static {
    this.TaxListSorting = "/API/Setup/SortTax";
  }
  // ESTIMATE
  static {
    this.LoadFormEstimate = "/API/Estimate/LoadForm";
  }
  static {
    this.EstimateGenerateNumber = "/API/Estimate/GenerateNumber";
  }
  static {
    this.SubmitEstimate = "/API/Estimate/SubmitOrder";
  }
  // ADJUSTMENT
  static {
    this.LoadFormAdjustment = "/API/Adjustment/LoadForm";
  }
  static {
    this.AdjustmentGenerateNumber = "/API/Adjustment/GenerateNumber";
  }
  static {
    this.SubmitAdjustment = "/API/Adjustment/SubmitOrder";
  }
  // INVENTORY
  static {
    this.ForecastData = "Inventory/Daystozero";
  }
  static {
    this.ForecastLoader = "InventoryLoader/Daystozero";
  }
}

/**
 * Generated bundle index. Do not edit.
 */

export { Constants, LocalDataKey, getImageInfo };
